/* istanbul ignore next */
export enum UserAction {
  CancelledRegistration = "User cancelled their registration",
}
